import { Component, Renderer2, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-front-page',
  templateUrl: './front-page.component.html',
  styleUrls: ['./front-page.component.css']
})
export class FrontPageComponent implements OnInit, OnDestroy {
  isOpened = false;
  audio = new Audio();
  isPlaying = false;

  constructor(private renderer: Renderer2) {
    // Configura la ruta de tu archivo MP3 aquí
    this.audio.src = 'assets/audio/musica.mp3';
    this.audio.loop = true;
  }

  ngOnInit() {
    this.renderer.addClass(document.body, 'no-scroll');
  }

  openEnvelope() {
    this.isOpened = true;
    this.renderer.removeClass(document.body, 'no-scroll');
    
    // Iniciar música
    this.audio.play();
    this.isPlaying = true;
  }

  toggleMusic() {
    if (this.isPlaying) {
      this.audio.pause();
    } else {
      this.audio.play();
    }
    this.isPlaying = !this.isPlaying;
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'no-scroll');
    this.audio.pause();
    this.audio.src = '';
  }
}